import { JsonObject, JsonProperty, JsonDelayedProperty, DateConverter } from 'projects/core/src/public-api';
import { TrelloObject } from './trello-object';
import { TrelloChecklist } from './trello-checklist';
import { UserMention } from '../../mentions/data/user-mention';
import { ProjectFile } from '../../project-misc/data/project/project-file';
import { User } from 'projects/core/src/lib/login/data/user';
import { CheckItemHeadTag } from './checkitem-head-tag';
import { CheckItemTask } from './trello-task';
import { ShortTask } from 'projects/desktop/src/app/modules/home-page/data/tasks/short-task';

@JsonObject('model.trello.TrelloCheckItem')
export class TrelloCheckItem extends TrelloObject {

    @JsonDelayedProperty('TrelloCheckItem', 'TrelloChecklist', 'checklist')
    checklist?: TrelloChecklist;

    @JsonProperty(Boolean, 'ready')
    ready?= false;

    @JsonProperty(Number, 'checklistId')
    checklistId?: number;

    @JsonProperty(String, 'state')
    state?: string;

    @JsonProperty([UserMention], 'mentions')
    mentions?: UserMention[];

    @JsonProperty([ProjectFile], 'files')
    files?: ProjectFile[] = [];

    @JsonProperty(Number, 'tasksDone')
    tasksDone?: number;

    @JsonProperty(Number, 'tasksTotal')
    tasksTotal?: number;

    @JsonProperty(DateConverter, 'toggleDate')
    toggleDate?: Date;

    @JsonProperty(User, 'toggledBy')
    toggledBy?: User;

    @JsonProperty([String], 'tagTypes')
    tagTypes?: string[];

    @JsonProperty(Number, 'amount')
    amount?: number;

    @JsonProperty([CheckItemHeadTag], 'tags')
    tags?: CheckItemHeadTag[];

    @JsonProperty(Number, 'pos')
    pos?: number;

    @JsonProperty([CheckItemTask], 'workOrderTasks')
    workOrderTasks?: CheckItemTask[];

    @JsonProperty(ShortTask, 'taskDto')
    taskDto?: ShortTask;

  @JsonProperty(User, 'addedToSoBy')
  addedToSoBy?: User;

  @JsonProperty(DateConverter, 'addedToSoDate')
  addedToSoDate?: Date;

    workOrder?: boolean;

    changeOrderAmount?: number

    collapsed?: boolean;
}
